import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=46da22c3&"
var script = {}
import style0 from "./MenuList.vue?vue&type=style&index=0&id=46da22c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports